import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import PageContainer from "../../components/PageContainer/PageContainer";
import { URLs } from "../../utils/redirectStep";
import { getSessionDocument } from "services/sessionStorageService";

function EnProceso() {
  const navigate = useNavigate();
  const location = useLocation();

  const modal = {
    open: true,
    showX: true,
    message:
      '<p className={classes.modalMessage}> Actualmente tiene una <span style="color: #d00771!important">solicitud en proceso de aprobación.</span><br /><br />Por favor, espere que un asesor de atención al cliente se contacte por teléfono.</p>',
  };

  useEffect(() => {
    const documento = getSessionDocument();
    if (!documento) {
      navigate(URLs.home);
    }
  }, []);

  const handleModalCloseClick = () => {
    window.location.href = "https://italmundo.com.uy/";
  };

  return (
    <PageContainer
      modal={modal}
      handleModalCloseClick={handleModalCloseClick}
      canonicalUrl={URLs.enProcesoAprobacion}
      noImage={true}
    />
  );
}

export default EnProceso;
